<template>
  <div class="page-component-wrapper">
    <grid
      ref="gridRef"
      :config="gridConfig"
      @handleCustomButtonGrid="goTo"
    >
      <template v-if="isHighPermission" v-slot:inner-tools>
        <div class="d-flex justify-content-center align-items-center">
          <el-button type="danger" size="small" @click="isVisibleRemoveDialog = true">{{L10n('remove-records')}}</el-button>
        </div>
      </template>
    </grid>
    <el-dialog
      :title="L10n('remove-payments-logs')"
      :visible.sync="isVisibleRemoveDialog"
      append-to-body
      v-loading="isLoading"
    >
      <div class="d-flex flex-column justify-content-center align-items-center">
        <span class="mb-4">{{L10n('content-delete-payments-log')}}</span>
        <div>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            :unlink-panels="true"
            :start-placeholder="L10n('start-date')"
            :end-placeholder="L10n('end-date')"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="isVisibleRemoveDialog = false"
        >
          {{L10n('cancel')}}
        </el-button>
        <el-button
          size="small"
          type="danger"
          @click="onDelete"
          :disabled="!dateRange"
        >
          {{L10n('delete')}}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="L10n('confirm')"
      :visible.sync="isVisibleConfirmDialog"
      append-to-body
    >
      <span>{{L10n("are-you-sure") + " " + countDelete + " " + L10n('records')}}</span>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="small"
          @click="isVisibleConfirmDialog = false"
        >
          {{L10n('cancel')}}
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="onConfirmRemove"
          :disabled="!dateRange"
        >
          {{L10n('confirm')}}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import gridConfig from './GridConfig.js'
import { createFilterDateRange } from '@/services/filters'
import { ServicePayments } from '@/services/Payments'

export default {
  name: 'StocksParts',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index')
  },
  computed: {
    gridConfig () {
      return gridConfig()
    },
    isHighPermission () {
      return this.$store.getters.isHighPermission
    }
  },
  data () {
    return {
      isVisibleRemoveDialog: false,
      isVisibleConfirmDialog: false,
      dateRange: null,
      countDelete: 0,
      isLoading: false
    }
  },
  methods: {
    async onDelete () {
      this.isLoading = true
      try {
        const { data: { count } } = await ServicePayments.getAllDynamicLogs(
          { filter: createFilterDateRange('entryDate', this.dateRange), count: true }
        )
        this.countDelete = count
        this.isVisibleConfirmDialog = true
      } catch (e) {
        this.requestErrorHandler(e, e.message)
      } finally {
        this.isLoading = false
      }
    },
    async onConfirmRemove () {
      this.isLoading = true
      this.isVisibleConfirmDialog = false
      try {
        const { count, countSuccess, countError } = await ServicePayments
          .deleteLogsDynamic({ filter: createFilterDateRange('entryDate', this.dateRange) })
        this.$notify.info({
          title: this.L10n('info'),
          dangerouslyUseHTMLString: true,
          message: `
            <strong>${this.L10n('total')}</strong>: ${count},
            </br><strong>${this.L10n('count-success')}</strong>: ${countSuccess},
            </br><strong>${this.L10n('count-error')}</strong>: ${countError}`
        })
      } catch (e) {
        this.requestErrorHandler(e, e.message)
      } finally {
        this.$refs.gridRef.requestGetData()
        this.isLoading = false
        this.isVisibleRemoveDialog = false
        this.countDelete = false
        this.dateRange = null
      }
    },
    goTo ({ row }) {
      this.$router.push({
        name: 'Payments',
        query: {
          'payments': `edit[${row.paymentID}]`
        }
      })
    }
  }
}
</script>
